import {
  FilledInput,
  FormControl,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  Send as SendIcon,
  Store as StoreIcon,
  Phone as PhoneIcon,
} from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";
import * as Styled from "./styles";
import { MessageData, useChat } from "./useChat";
import { getDisplayPhone } from "./utils";

const WebViewMobile = () => {
  function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const { chatData, dataUser, handleSendNewMessage } = useChat(
    query.get("token")?.toString() || "",
  );
  const [currentChat, setCurrentChat] = useState<any>(chatData || null);

  const [inputMessage, setInputMessage] = useState("");

  useEffect(() => {
    const orderData =
      chatData.find(
        (order: any) => order.id === query.get("order-id")?.toString(),
      ) || [];

    setCurrentChat(orderData);
  }, [chatData, query]);

  const sendMessage = () => {
    if (!inputMessage) return;

    setInputMessage("");

    handleSendNewMessage({
      orderId: query.get("order-id")?.toString() || "",
      fromId: query.get("consumer-id")?.toString() || "",
      toId: query.get("dealer-id")?.toString() || "",
      message: inputMessage,
    });
  };
  const modRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    modRef.current?.scrollTo({
      top: modRef.current.scrollHeight,
      behavior: "smooth",
    });
  }, [currentChat]);

  return (
    <Styled.Container>
      <Styled.Grid>
        {currentChat && (
          <Styled.GridRight>
            <Styled.CardContainer space="24px 24px">
              <Typography>Você está falando com</Typography>
              <Styled.ContainerIcon>
                <StoreIcon />
                <Typography variant="h5">{dataUser?.tradeName}</Typography>
              </Styled.ContainerIcon>

              <Styled.ContainerIcon>
                <PhoneIcon />
                <Typography variant="h5">
                  {getDisplayPhone(dataUser?.telephone, dataUser?.cellphone)}
                </Typography>
              </Styled.ContainerIcon>
              <Styled.ContainerChat>
                <Styled.ContainerMessage>
                  <Styled.ContentMessage>
                    <Typography variant="body2" align="center">
                      Olá! Descreva brevemente o problema. A revenda vai
                      responder o mais rápido possível.
                    </Typography>
                  </Styled.ContentMessage>
                </Styled.ContainerMessage>

                <Styled.ContainerMessages ref={modRef}>
                  {chatData?.map((message: MessageData) => (
                    <>
                      <Styled.Message
                        key={message.message}
                        variant="body2"
                        textAlign="center"
                        alignSelf={
                          message.fromId ===
                          query.get("consumer-id")?.toString()
                            ? "flex-end"
                            : "flex-start"
                        }
                      >
                        <Typography>{message.message}</Typography>
                      </Styled.Message>
                      <Typography
                        color="rgba(0, 0, 0, 0.38)"
                        fontSize={12}
                        alignSelf={
                          message.fromId ===
                          query.get("consumer-id")?.toString()
                            ? "flex-end"
                            : "flex-start"
                        }
                      >
                        {format(new Date(message.time || Date()), "HH:mm")}
                      </Typography>
                    </>
                  ))}
                </Styled.ContainerMessages>
                <Styled.MessagesInput>
                  <FormControl sx={{ m: 1 }} variant="filled">
                    <FilledInput
                      id="filled-adornment-password"
                      type="text"
                      value={inputMessage}
                      onKeyPress={(ev) => {
                        if (ev.key === "Enter") {
                          sendMessage();
                        }
                      }}
                      onChange={(ev) => setInputMessage(ev.target.value)}
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={sendMessage}
                            edge="end"
                            sx={{ marginRight: 0.5 }}
                          >
                            <SendIcon />
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </FormControl>
                </Styled.MessagesInput>
              </Styled.ContainerChat>
            </Styled.CardContainer>
          </Styled.GridRight>
        )}
      </Styled.Grid>
    </Styled.Container>
  );
};

export default WebViewMobile;
